import React, { useState, useEffect } from "react";
import MapImage from "../../assets/map.png";
import {
  ZoomWrapper,
  MainContainer,
  TopBarThing,
  MapContainer,
  Map,
  PlayerEmblem,
  EmblemImage,
  FlagsWrapper,
  YellowFlag,
} from "./MapPage.style";
import Flag from "../../assets/yellow-flag.png";
import FailFlag from "../../assets/white-flag.svg";
import Information from "../../components/Information";
import GameRulesModal from "../../components/Modals/GameRulesModal";
import { Greece1600 } from "./MapPage.style";
import Text from "../../components/Text";
import Castle from "../../components/Castle";
import { PlayerBanner } from "./MapPage.style";
import CastleDetails from "../CastlePage/CastleDetails"; // Changed import
import { fetchUserProgress, fetchGameplayCount } from "../../API/progress"; // Fetch user progress API
import { fetchUserEmblem, getEmblemImagePath } from "../../API/emblem"; // Fetch emblem API
import "../../index.css";

const MapPage = ({
  selectedDifficulty,
  setSelectedDifficulty,
  selectedCastle,
  setSelectedCastle,
}) => {
  const [openGameRules, setOpenGameRules] = useState(false);
  const [openCastleDetails, setOpenCastleDetails] = useState(false);
  const [userProgress, setUserProgress] = useState({ score: 0, conquered: 0 });
  const [userEmblem, setUserEmblem] = useState(null);
  const [userColor, setUserColor] = useState(null);
  const [failedCastles, setFailedCastles] = useState([]);
  const [conqueredCastles, setConqueredCastles] = useState([]);
  const [conqueredCastleColors, setConqueredCastleColors] = useState({});
  const [isProgressLoaded, setIsProgressLoaded] = useState(false);
  const [zoomed, setZoomed] = useState(false);
  const [zoomTransform, setZoomTransform] = useState(""); // will hold CSS value






  

  // ✅ Retrieve user ID from sessionStorage
  const userId = sessionStorage.getItem("user_id");
  

  useEffect(() => {
    sessionStorage.removeItem("audio_listened_percent");
    sessionStorage.removeItem("audio_2_listened_percent");
    sessionStorage.removeItem("castle_audio_step");
    const isGuest = sessionStorage.getItem("is_guest") === "true";
    const storedFails = JSON.parse(sessionStorage.getItem("failed_castles") || "[]");
    const storedConquered = JSON.parse(sessionStorage.getItem("conquered_castles") || "[]");
    const storedColors = JSON.parse(sessionStorage.getItem("conquered_castle_colors") || "{}");
  
    setFailedCastles(storedFails);
    setConqueredCastles(storedConquered);
    setConqueredCastleColors(storedColors);
  
    if (isGuest) {
      // 🟡 Guest user: read from session only
      const guestScore = parseInt(sessionStorage.getItem("points_guest") || "0", 10);
      const guestEmblem = sessionStorage.getItem("emblem_id");
      const guestColor = sessionStorage.getItem("color");
  
      setUserProgress({ score: guestScore, conquered: storedConquered.length });
      setUserEmblem(guestEmblem || "1"); // fallback if missing
      setUserColor(guestColor || "blue");
      setIsProgressLoaded(true);
    } else if (userId) {
      // 🟢 Logged-in user: fetch from API
      const fetchProgress = async () => {
        try {
          const response = await fetchUserProgress(userId);
  
          if (response.success && response.data?.data) {
            const { score = 0, conquered_castles = [] } = response.data.data;
            setUserProgress({ score, conquered: conquered_castles.length });
            setConqueredCastles(conquered_castles);
            sessionStorage.setItem(`points_${userId}`, score.toString());
            sessionStorage.setItem("conquered_castles", JSON.stringify(conquered_castles));
          }
  
          const gameplayRes = await fetchGameplayCount(userId);
          if (gameplayRes.success && gameplayRes.data?.count) {
            const count = gameplayRes.data.count;
            sessionStorage.setItem("gameplay_number", count.toString());
            if (count > 1) {
              sessionStorage.setItem("allow_replay_conquered", "true");
            } else {
              sessionStorage.removeItem("allow_replay_conquered");
            }
          }
  
          const emblemRes = await fetchUserEmblem();
          if (emblemRes.success) {
            setUserEmblem(emblemRes.data.emblem_id);
            setUserColor(emblemRes.data.color);
          }
  
          setIsProgressLoaded(true);
        } catch (err) {
          console.error("❌ Error loading user progress/emblem", err);
          setIsProgressLoaded(true);
        }
      };
  
      fetchProgress();
    }
  }, [userId]);
  
  



  // 👇 Replace the whole zoom logic inside handleCastleClick:
const handleCastleClick = (castleId) => {
  const castleElement = document.getElementById(`castle-${castleId}`);
  const mapContainer = document.querySelector(".map-container");

  if (castleElement && mapContainer) {
    const castleRect = castleElement.getBoundingClientRect();
    const mapRect = mapContainer.getBoundingClientRect();

    const centerX = castleRect.left + castleRect.width / 2;
    const centerY = castleRect.top + castleRect.height / 2;

    const viewportCenterX = window.innerWidth / 2;
    const viewportCenterY = window.innerHeight / 2;

    const scale = 1.4;

    let deltaX = viewportCenterX - centerX;
    let deltaY = viewportCenterY - centerY;

    const maxX = (mapRect.width * (scale - 1)) / 2;
    const maxY = (mapRect.height * (scale - 1)) / 2;

    deltaX = Math.max(-maxX, Math.min(maxX, deltaX));
    deltaY = Math.max(-maxY, Math.min(maxY, deltaY));

    const transformString = `translate(${deltaX}px, ${deltaY}px) scale(${scale})`;
    setZoomTransform(transformString);
  }

  setSelectedCastle(castleId);
  setOpenCastleDetails(true);
};
  

 const castles = [
  { id: 3, left: 17, top: 16.5, variant: 2, zindex: 1 },
  { id: 10, left: 21.5, top: 44.5, variant: 2, zindex: 2 },
  { id: 8, left: 26, top: 48.5, variant: 1, zindex: 3 },
  { id: 9, left: 23.2, top: 49.5, variant: 2, zindex: 4 },
  { id: 6, left: 29.8, top: 41, variant: 1, zindex: 1 },
  { id: 7, left: 36.5, top: 49, variant: 2, zindex: 6 },
  { id: 11, left: 39, top: 45, variant: 2, zindex: 4 },
  { id: 1, left: 33.5, top: 60, variant: 1, zindex: 8 },
  { id: 5, left: 38.5, top: 66, variant: 2, zindex: 9 },
  { id: 2, left: 27.5, top: 61.5, variant: 2, zindex: 7 },
  { id: 4, left: 28.5, top: 65, variant: 1, zindex: 11 },
];


  return (
    

   <MainContainer>
  <GameRulesModal open={openGameRules} handleClose={setOpenGameRules} />

  <CastleDetails
    open={openCastleDetails}
    handleClose={() => {
      setOpenCastleDetails(false);
      setZoomTransform(""); // ✅ Reset zoom
    }}
    selectedDifficulty={selectedDifficulty}
    setSelectedDifficulty={setSelectedDifficulty}
    castleId={selectedCastle}
  />

  <TopBarThing>
    <Greece1600>
      <Text fontFamily="'Source Serif 4'" fontSize="30px" color="#F3DE8A" fontWeight="bold">
        Ελλάδα
      </Text>
      <Text
        fontFamily="CaniculeDisplay-Bold"
        fontSize="20px"
        fontWeight={700}
        color="#F3DE8A"
        lineheight="156%"
      >
        1600
      </Text>
    </Greece1600>
    <Information
      marginTop="10px"
      open={openGameRules}
      handleClick={setOpenGameRules}
    />
  </TopBarThing>
{isProgressLoaded ? (
        <PlayerBanner>
          <PlayerEmblem>
            {userEmblem && userColor ? (
              <EmblemImage src={getEmblemImagePath(userEmblem, userColor)} />
            ) : (
              <Text color="#F3DE8A"></Text>
            )}
          </PlayerEmblem>

          <FlagsWrapper>
            {[0, 1, 2].map(i => (
              <YellowFlag key={i} src={failedCastles.length > i ? FailFlag : Flag} />
            ))}
          </FlagsWrapper>

          <div style={{ textAlign: "center" }}>
            <Text fontFamily="'Source Serif 4'" color="#FFFBEC" fontSize="30px" fontWeight={700}>
              {userProgress.score}
            </Text>
            <Text fontFamily="'Source Serif 4'" color="#FFFBEC" fontSize="16px" fontWeight={400}>
              Σκορ
            </Text>
          </div>

          <div style={{ textAlign: "center", marginBottom: "-50px" }}>
            <Text fontFamily="'Source Serif 4'" color="#FFFBEC" fontSize="30px" fontWeight={700}>
              {userProgress.conquered}/11
            </Text>
            <Text fontFamily="'Source Serif 4'" color="#FFFBEC" fontSize="16px" fontWeight={400}>
              Κάστρα
            </Text>
          </div>
        </PlayerBanner>
      ) : (
        <Text color="#fff">Loading player progress...</Text>
      )}
  <ZoomWrapper style={{ transform: zoomTransform }}>
    <MapContainer className="map-container">
      

      <Map src={MapImage} />

      {castles.map(({ id, left, top, variant, zindex }) => (
        <Castle
          key={id}
          domId={`castle-${id}`}
          left={left}
          top={top}
          open={openCastleDetails}
          id={id}
          handleClick={handleCastleClick}
          variant={variant}
          zindex={zindex}
          selectedColor={userColor}
          isFailed={failedCastles.includes(id)}
          isConquered={conqueredCastles.includes(id)}
        />
      ))}
    </MapContainer>
  </ZoomWrapper>
</MainContainer>

    
  );
};

export default MapPage;
